import React from 'react';

import Handscroll from './Handscroll';
import Hangingscroll from './Hangingscroll';

const Scroll = ({
  children,
  axis = 'x',
  fillScreen = false,
}) => (
  <div className={`position-relative scroll-${axis}`}>
    {axis === 'x' && (
      <>
        <Handscroll className="d-none d-md-block" />
        <Hangingscroll className="d-block d-md-none" />
      </>
    )}
    {axis === 'y' && (
      <Hangingscroll />
    )}

    <div className="position-relative scroll-content">
      <div className={fillScreen ? 'fill-screen' : ''}>
        {children}
      </div>
    </div>
  </div>
);

export default Scroll;
